export const MAX_IMAGE_UPLOAD_BYTES = Math.floor(4.5 * 1024 * 1024);

export const isImageSizeAllowed = (
  file: File,
  maxBytes: number = MAX_IMAGE_UPLOAD_BYTES,
): boolean => file.size <= maxBytes;
